import CitySEOHead from "@/components/feature/CitySEOHead";
import FayettevilleHeroSection from "./components/HeroSection";
import FayettevilleARStickyNav from "./components/StickyNav";
import FayettevilleARProcessingTimeSection from "./components/ProcessingTimeSection";
import FayettevilleARServicesSection from "./components/ServicesSection";
import FayettevilleARLocalAreaSection from "./components/LocalAreaSection";
import FayettevilleARTravelTimingSection from "./components/TravelTimingSection";
import FayettevilleARDestinationsSection from "./components/DestinationsSection";
import FayettevilleARTestimonialsSection from "./components/TestimonialsSection";
import FayettevilleARAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import FayettevilleARComparisonSection from "./components/ComparisonSection";
import FayettevilleARMistakesSection from "./components/MistakesSection";
import FayettevilleARHowItWorksSection from "./components/HowItWorksSection";
import FayettevilleARFAQSection, { faqs } from "./components/FAQSection";
import FayettevilleARHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FayettevilleARFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
];

export default function FayettevilleARPage() {
  return (
    <>
      <CitySEOHead
        city="Fayetteville"
        state="Arkansas"
        stateAbbr="AR"
        route="/cities/fayetteville-ar"
        title="Emergency Passport Fayetteville, AR — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Fayetteville, AR — as fast as 24 hours. Serving UA students, Walmart corporate travelers, Tyson Foods professionals, JB Hunt logistics teams, and NWA families. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Fayetteville, Arkansas"
        geoPosition="36.0626;-94.1574"
        faqs={faqs}
        servicesSchema={servicesSchema}
        statePageName="Arkansas"
        statePageRoute="/states/arkansas"
      />
      <div className="font-sans">
        <FayettevilleHeroSection />
        <FayettevilleARStickyNav />
        <FayettevilleARProcessingTimeSection />
        <FayettevilleARLocalAreaSection />
        <FayettevilleARServicesSection />
        <FayettevilleARTravelTimingSection />
        <FayettevilleARDestinationsSection />
        <FayettevilleARTestimonialsSection />
        <FayettevilleARAcceptanceFacilitiesSection />
        <FayettevilleARComparisonSection />
        <FayettevilleARMistakesSection />
        <FayettevilleARHowItWorksSection />
        <FayettevilleARFAQSection />
        <FayettevilleARHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/fayetteville-ar" state="AR" />
        <FayettevilleARFinalCTA />
      </div>
    </>
  );
}